export default class DtoAgriTanksType {
    constructor(obj) {
        this.id = obj.id // Long,
        this.name = obj.name // Option[String],
        this.eligibility = obj.eligibility // Option[Boolean],
        this.percent = obj.percent // Option[Double],
        this.updateDate = obj.updateDate // Option[DateTime],
        this.updateLogin = obj.updateLogin // Option[String]
    }
}